import * as S from './styles';

interface SOComponentItem {
  message?: string;
  activeClub: boolean;
}

export default function SOComponentItem({
  message,
  activeClub,
}: SOComponentItem) {
  return (
    <S.Container className="so-component-item">
      <a
        href={
          activeClub
            ? '/central-do-cliente/clube-sidney-oliveira'
            : '/clube-sidney-oliveira'
        }
        className="so-component-item-content"
      >
        <div className="club-header-images">
          <img
            src="/images/sidney-oliveira-club/sub-logo.png"
            alt="Logo Clube Sidney Oliveira"
            className="logo"
          />
          <span>CLUBE SIDNEY OLIVEIRA</span>
        </div>

        <div className="so-component-message">
          {message && (
            <p
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          )}

          {activeClub ? (
            <p>
              *Clique aqui, consulte seu <b>saldo disponível</b> e regulamento!
            </p>
          ) : (
            <p>
              Clique aqui, faça parte do Clube e receba <b>cashbacks</b> por
              suas compras!
            </p>
          )}
        </div>
      </a>
    </S.Container>
  );
}
